export default "__VITE_ASSET__AGXdfoyg__";